/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponsePagedResultUiNotificationResponse } from '../models/api-response-paged-result-ui-notification-response';
import { searchNotificationState } from '../fn/notification-api/search-notification-state';
import { SearchNotificationState$Params } from '../fn/notification-api/search-notification-state';

@Injectable({ providedIn: 'root' })
export class NotificationApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `searchNotificationState()` */
  static readonly SearchNotificationStatePath = '/v1/api/ui/notification/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchNotificationState()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchNotificationState$Response(params: SearchNotificationState$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultUiNotificationResponse>> {
    return searchNotificationState(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchNotificationState$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchNotificationState(params: SearchNotificationState$Params, context?: HttpContext): Observable<ApiResponsePagedResultUiNotificationResponse> {
    return this.searchNotificationState$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultUiNotificationResponse>): ApiResponsePagedResultUiNotificationResponse => r.body)
    );
  }

}
